import { IconProps } from "./type";

const GoogleAuthenticatorIcon = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="25"
      height="22"
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5074 10.8887C24.5074 12.0298 23.5833 12.9539 22.4422 12.9539H15.3173L12.2539 6.75826L15.5598 1.03232C16.1316 0.044382 17.3927 -0.292588 18.3806 0.276687C19.3686 0.848516 19.7055 2.1096 19.1363 3.09754L15.8304 8.82348H22.4422C23.5833 8.82348 24.5074 9.74759 24.5074 10.8887Z"
        fill="#1A73E8"
      />
      <path
        d="M18.3795 21.5005C17.3916 22.0697 16.1305 21.7328 15.5587 20.7448L12.2528 15.0189L8.94692 20.7448C8.37509 21.7328 7.114 22.0697 6.12607 21.5005C5.13813 20.9286 4.80116 19.6675 5.37044 18.6796L8.67632 12.9537L12.2528 12.8184L15.8293 12.9537L19.1352 18.6796C19.7044 19.6675 19.3675 20.9286 18.3795 21.5005Z"
        fill="#EA4335"
      />
      <path
        d="M12.2528 6.75826L11.321 9.29064L8.67632 8.82348L5.37044 3.09754C4.80116 2.1096 5.13813 0.848516 6.12607 0.276687C7.114 -0.292588 8.37509 0.044382 8.94692 1.03232L12.2528 6.75826Z"
        fill="#FBBC04"
      />
      <path
        d="M11.7199 8.82324L9.32284 12.9537H2.06522C0.924115 12.9537 0 12.0296 0 10.8885C0 9.74736 0.924115 8.82324 2.06522 8.82324H11.7199Z"
        fill="#34A853"
      />
      <path
        d="M15.8287 12.954H8.67578L12.2523 6.7583L15.8287 12.954Z"
        fill="#185DB7"
      />
    </svg>
  );
};

export default GoogleAuthenticatorIcon;
